import ApiConfig from '../apiconfig';

const enableDmarc = () => ApiConfig.enableDmarc;

export { enableDmarc };
